import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const InputField = ({ label, type = 'text', placeholder, value, onChange, required }) => (
  <div>
    <label className="block text-[#9a9890] text-xs font-semibold uppercase tracking-wider mb-2">{label}</label>
    {type === 'textarea' ? (
      <textarea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        rows={5}
        required={required}
        className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white text-sm placeholder:text-[#4a4a50] focus:outline-none focus:border-[#c9a84c]/60 transition-colors resize-none"
      />
    ) : (
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white text-sm placeholder:text-[#4a4a50] focus:outline-none focus:border-[#c9a84c]/60 transition-colors"
      />
    )}
  </div>
);

export const Contacto = () => {
  const [form, setForm] = useState({ nombre: '', email: '', asunto: '', mensaje: '' });
  const [sent, setSent] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <div className="min-h-screen" style={{ background: '#050508', color: '#e8e6e0' }}>
      <nav className="px-6 md:px-12 py-5 flex items-center gap-3 border-b border-white/5">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: '#0d0d10', border: '1.5px solid rgba(201,168,76,0.3)' }}>
            <svg viewBox="0 0 40 40" width="24" height="24" fill="none">
              <polygon points="20,5 4,18 36,18" fill="#f0c040"/>
              <rect x="26" y="8" width="4" height="8" fill="#f0c040"/>
              <rect x="7" y="18" width="26" height="17" fill="#f0c040"/>
              <rect x="15" y="25" width="10" height="10" fill="#050508" rx="1"/>
              <circle cx="23" cy="30" r="1" fill="#c9a84c"/>
              <rect x="9" y="20" width="7" height="6" fill="#050508" rx="1"/>
              <rect x="24" y="20" width="7" height="6" fill="#050508" rx="1"/>
            </svg>
          </div>
          <span className="font-display font-bold text-white tracking-tight">E-<span className="text-[#c9a84c]">HOME</span></span>
        </Link>
      </nav>

      <main className="max-w-5xl mx-auto px-6 py-16">
        <div className="mb-12">
          <p className="text-[#c9a84c] text-xs font-semibold uppercase tracking-widest mb-3">Soporte</p>
          <h1 className="font-display font-black text-4xl md:text-5xl text-white mb-4">Contacta con nosotros</h1>
          <p className="text-[#7a7870] text-lg">Estamos aquí para ayudarte. Respuesta en menos de 24 horas.</p>
        </div>

        <div className="grid md:grid-cols-5 gap-12">
          {/* Info */}
          <div className="md:col-span-2 space-y-8">
            {[
              { icon: '✉', label: 'Email', value: 'info@iaconsultora.com', href: 'mailto:info@iaconsultora.com' },
              { icon: '🏠', label: 'Plataforma', value: 'ehomesp.com', href: '/' },
            ].map(({ icon, label, value, href }) => (
              <div key={label}>
                <p className="text-[#c9a84c] text-xs font-semibold uppercase tracking-wider mb-1">{icon} {label}</p>
                <a href={href} className="text-white hover:text-[#c9a84c] transition-colors text-sm">{value}</a>
              </div>
            ))}

            <div className="rounded-2xl p-6" style={{ background: 'rgba(201,168,76,0.06)', border: '1px solid rgba(201,168,76,0.15)' }}>
              <p className="text-[#c9a84c] font-semibold text-sm mb-2">¿Eres agente o gestoría?</p>
              <p className="text-[#7a7870] text-xs leading-relaxed mb-4">Descubre cómo cientos de profesionales ya gestionan su cartera con E-HOME.</p>
              <Link to="/agentes" className="inline-block text-xs font-bold text-black px-4 py-2 rounded-lg" style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c870)' }}>
                Ver planes →
              </Link>
            </div>
          </div>

          {/* Form */}
          <div className="md:col-span-3">
            {sent ? (
              <div className="flex flex-col items-center justify-center h-full py-16 text-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ background: 'rgba(201,168,76,0.15)', border: '1px solid rgba(201,168,76,0.3)' }}>
                  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#c9a84c" strokeWidth="2.5">
                    <polyline points="20,6 9,17 4,12"/>
                  </svg>
                </div>
                <h2 className="text-white font-display font-bold text-2xl mb-2">Mensaje enviado</h2>
                <p className="text-[#7a7870] text-sm">Te responderemos en menos de 24 horas.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid sm:grid-cols-2 gap-5">
                  <InputField label="Nombre" placeholder="Tu nombre" value={form.nombre} onChange={set('nombre')} required />
                  <InputField label="Email" type="email" placeholder="tu@email.com" value={form.email} onChange={set('email')} required />
                </div>
                <InputField label="Asunto" placeholder="¿En qué podemos ayudarte?" value={form.asunto} onChange={set('asunto')} required />
                <InputField label="Mensaje" type="textarea" placeholder="Cuéntanos más..." value={form.mensaje} onChange={set('mensaje')} required />
                <button type="submit"
                  className="w-full font-display font-bold text-black py-4 rounded-xl transition-all duration-300 hover:shadow-[0_0_40px_rgba(201,168,76,0.4)] hover:-translate-y-0.5"
                  style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c870)' }}>
                  Enviar mensaje →
                </button>
              </form>
            )}
          </div>
        </div>
      </main>

      <footer className="border-t border-white/5 px-6 py-8 text-center">
        <p className="text-[#7a7870] text-xs">© 2026 ehomesp.com · <Link to="/privacidad" className="hover:text-[#c9a84c] transition-colors">Privacidad</Link> · <Link to="/cookies" className="hover:text-[#c9a84c] transition-colors">Cookies</Link> · <Link to="/contacto" className="hover:text-[#c9a84c] transition-colors">Contacto</Link></p>
      </footer>
    </div>
  );
};

export default Contacto;
